import { Injectable } from '@angular/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
  TEST_NAME_API: string;
  ADD_ITEM_API: string;
  DELETE_ITEM_API: string;
  REASSIGN_ITEM_API: string;
  ACTION_BY_ID: string;
  BUSINESS_ID: string[];
  CHANNEL_CODE: string;
  DATE_FILTER: string;
  ORDER_LIST_METHOD: string;
  METHOD_TYPE: string; x
  SORT_BY: string;
  LIMIT: string;
  SKIP: String;
  REASSIGN_ORDER_API: string;
  ROLE_ID: string;
  RESCHEDULE_ROLE_ID: string;
  STATUS: number;
  CATEGORY_ID: Number;
  SUB_CATEGORY_ID: Number;
  SOURCE: String;
  OTP_VERIFY_METHOD: string;
  ACTION_BY_NAME: string;
  ACTION: number;
  L2_ROLES: Array<string>;
  DC_ROLES: Array<string>;
  PRESCRIPTION_PENDING_STATUS: Number;
  CUSTOMER_REACHED_STATUS: Number;
  REPORT_UPLOADED_STATUS: Number;
  ORDER_REJECTION_STATUS: Number;
  IS_UCD_ORDER: string;
  ENGAGE_AT: string;
 
  ASSOCIATE_NAME: string;
  RETAINED:string;
  SERVICE_TYPE:string;
  LOGIN_ASSOCIATE_ID: string;
  LOGIN_ASSOCIATE_BRANCH_ID: string;
  PRESCRIPTION_UPLOADED_STATUS : Number;
  REPORT_UPLOAD_READY_STATUS: Number;
  constructor() {
    this.TEST_NAME_API = 'http://gcmuatv3.callhealth.com:8080/mdm_v3/services/fetchservice/getAllAssociateServices';
    this.ADD_ITEM_API = 'https://omsuatv3.callhealth.com/OMS/api/operation.php/v1/order/lineitem/crud/multi';
    this.DELETE_ITEM_API = 'https://omsuatv3.callhealth.com/OMS/api/operation.php/v1/order/lineitem/crud';
    this.REASSIGN_ITEM_API = 'http://gcmuatv3.callhealth.com:8080/mdm_v3/services/fetchservice/getServicesInfo';
    this.ACTION_BY_ID = localStorage.getItem('actionById');
    //this.ACTION_BY_ID = "900001";
    this.BUSINESS_ID = ['3','4'];
    this.CHANNEL_CODE = '2';
    // this.DATE_FILTER = 'created_date';
    this.DATE_FILTER = 'scheduled_date';
    this.ORDER_LIST_METHOD = 'OMS/api/operation.php/v1/orderswithcount';
    this.METHOD_TYPE = 'post';
    this.SORT_BY = 'desc';
    this.LIMIT = 'post';
    this.SKIP = 'post';
    
    this.ROLE_ID = localStorage.getItem('role');
    //this.ROLE_ID = "26";
    //this.RESCHEDULE_ROLE_ID = "1";
    this.STATUS = 7;
    this.CATEGORY_ID = 1;
    this.SUB_CATEGORY_ID = 3;
    this.SOURCE = "1";
    this.OTP_VERIFY_METHOD = "api/otp/validate";
    this.ACTION_BY_NAME = localStorage.getItem('actionByName');
    //this.ACTION_BY_NAME = "test";
    this.ACTION = 4;
    this.L2_ROLES = ["97"];
    this.DC_ROLES = ["0"];
    this.PRESCRIPTION_PENDING_STATUS = 26;
    this.CUSTOMER_REACHED_STATUS = 301;
    this.REPORT_UPLOADED_STATUS = 302;
    this.ORDER_REJECTION_STATUS = 9;
    this.IS_UCD_ORDER = "1";
    this.ENGAGE_AT = "2";
    this.RETAINED= "1";
    this.SERVICE_TYPE="2";
    this.LOGIN_ASSOCIATE_ID =window.localStorage.getItem('associateId');
    this.LOGIN_ASSOCIATE_BRANCH_ID=window.localStorage.getItem('branch_id');
    this.PRESCRIPTION_UPLOADED_STATUS = 26;
    this.REPORT_UPLOAD_READY_STATUS = 303;
  }
}
